"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Apollo = void 0;
// @ts-nocheck
const react_1 = __importStar(require("react"));
const client_1 = require("@apollo/client");
const error_1 = require("@apollo/client/link/error");
const cache = new client_1.InMemoryCache({
    possibleTypes: {
        Action: ['BuiltInAction', 'CommandReference'],
        Command: ['FormCommand'],
    },
});
const Apollo = ({ token, uri, children, onTokenExpired, onRedirectLogin }) => {
    const client = (0, react_1.useMemo)(() => {
        const request = async (operation) => {
            operation.setContext({
                headers: {
                    authorization: token ? 'Bearer ' + (await token()) : '',
                },
            });
        };
        const requestLink = new client_1.ApolloLink((operation, forward) => new client_1.Observable(observer => {
            let handle;
            Promise.resolve(operation)
                .then(oper => request(oper))
                .then(() => {
                handle = forward(operation).subscribe({
                    next: observer.next.bind(observer),
                    error: observer.error.bind(observer),
                    complete: observer.complete.bind(observer),
                });
            })
                .catch(observer.error.bind(observer));
            return () => {
                if (handle)
                    handle.unsubscribe();
            };
        }));
        return new client_1.ApolloClient({
            link: client_1.ApolloLink.from([
                (0, error_1.onError)(({ graphQLErrors, networkError }) => {
                    if (graphQLErrors) {
                        if (graphQLErrors.find(e => { var _a; return ((_a = e.extensions) === null || _a === void 0 ? void 0 : _a.code) === 'UNAUTHENTICATED'; })) {
                            onTokenExpired && onTokenExpired();
                            onRedirectLogin();
                        }
                        else if (graphQLErrors.filter(e => e.message.indexOf('expired') > -1).length > 0) {
                            onTokenExpired && onTokenExpired();
                            onRedirectLogin();
                        }
                    }
                    if (networkError && 'statusCode' in networkError && networkError.statusCode === 401) {
                        onTokenExpired && onTokenExpired();
                        onRedirectLogin();
                    }
                }),
                requestLink,
                new client_1.HttpLink({
                    uri,
                }),
            ]),
            cache,
        });
    }, [token, onTokenExpired, uri]);
    return react_1.default.createElement(client_1.ApolloProvider, { client: client }, children);
};
exports.Apollo = Apollo;
//# sourceMappingURL=apolloContext.js.map